module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "message__pic"
  }), _c('div', {
    staticClass: "message__block"
  }, [(_vm.msg.text.title) ? _c('h3', {
    staticClass: "message__title"
  }, [_vm._v(_vm._s(_vm.msg.text.title))]) : _vm._e(), (_vm.msg.text.warning) ? _c('p', {
    staticClass: "message__text success__text_warning"
  }, [_vm._v(_vm._s(_vm.msg.text.warning))]) : _vm._e(), (_vm.msg.text.description) ? _c('p', {
    staticClass: "message__text",
    class: {
      error_text: _vm.msg.type === "error"
    }
  }, [_vm._v(_vm._s(_vm.msg.text.description))]) : _vm._e(), _c('Button', {
    staticClass: "ok_button",
    attrs: {
      "size": "normal",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("understood")
      }
    }
  }, [_vm._v("Да, понятно")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48425941","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/request/components/finishMessage/FinishMessage.vue
// module id = f7616df991f92799e1ba
// module chunks = 0